import {combine} from 'effector';

import {deleteGtinApiV2, editGtinApiV2, recallGtin, uploadGtinApiV2} from 'api/registries/gtins';
import {rootDomain} from 'core/rootDomain';
import {GtinUploadDataItem} from 'types/gtins';

const domain = rootDomain.createDomain('UploadGtinsDomain');

export const uploadDataApiV2Fx = domain.createEffect({
    name: 'uploadDataApiV2Fx',
    handler: uploadGtinApiV2,
});

export const editGtinApiV2Fx = domain.createEffect<number, Record<string, any>>({
    name: 'editGtinApiV2Fx',
    handler: async (gtin) => {
        const data = (await editGtinApiV2(gtin)).fields;
        isFormModalOpenChanged(true);
        return data;
    },
});

export const recallGtinFx = domain.createEffect({
    name: 'recallGtinFx',
    handler: recallGtin,
});

export const deleteGtinApiV2Fx = domain.createEffect<number, void>({
    name: 'deleteGtinApiV2Fx',
    handler: async (gtin) => {
        await deleteGtinApiV2(gtin);
    },
});

export const data$ = domain.createStore<Array<Record<string, any>> | null>(null);
export const dataChanged = domain.createEvent<Array<GtinUploadDataItem> | null>();
export const isModalOpen$ = domain.createStore<boolean>(false);
export const isModalOpenChanged = domain.createEvent<boolean>();
export const dataSubmitted = domain.createEvent();

export const formData$ = domain.createStore<Array<Record<string, any>> | null>(null);
export const formDataChanged = domain.createEvent<Array<Record<string, any>> | null>();
export const isFormModalOpen$ = domain.createStore<boolean>(false);
export const isFormModalOpenChanged = domain.createEvent<boolean>();
export const formDataReset = domain.createEvent();
export const isRecallModalOpen$ = domain.createStore<boolean>(false);
export const isRecallModalOpenChanged = domain.createEvent<boolean>();

export const isRecallFailed$ = domain.createStore<boolean>(false);
export const isRecallFailedChanged = domain.createEvent<boolean>();

export const uploadState$ = combine({
    isRecallPending: recallGtinFx.pending,
    isRecallFailed: isRecallFailed$,
});
